import { render, staticRenderFns } from "./MemberCenterSettings.vue?vue&type=template&id=fdda2628&scoped=true&lang=pug&"
import script from "./MemberCenterSettings.vue?vue&type=script&lang=js&"
export * from "./MemberCenterSettings.vue?vue&type=script&lang=js&"
import style0 from "./MemberCenterSettings.vue?vue&type=style&index=0&id=fdda2628&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdda2628",
  null
  
)

export default component.exports